import { useEffect } from 'react';

const AutoClearLocalStorage = () => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userId');
      localStorage.removeItem('userData');
    }, 60 * 60 * 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  return null; // This component doesn't render anything
};

export default AutoClearLocalStorage;